import Verify from './src/verify/embedded';

globalThis.Verify = Verify;

export default Verify;
